import React, { createContext, useContext, useState, useEffect, useCallback } from "react";
import { getTranslation, LANGUAGES } from "./translations";

const LanguageContext = createContext(null);

function detectBrowserLanguage() {
  if (typeof navigator === "undefined") return "pl";
  const supported = LANGUAGES.map((l) => l.code);
  const nav = (navigator.languages && navigator.languages[0]) || navigator.language || "pl";
  const short = nav.toLowerCase().split("-")[0];
  if (supported.includes(short)) return short;
  // Default to Polish for first-time visitors when their language isn't supported
  return "pl";
}

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    const stored = typeof window !== "undefined" ? localStorage.getItem("vls.lang") : null;
    return stored || detectBrowserLanguage();
  });

  useEffect(() => {
    try {
      localStorage.setItem("vls.lang", lang);
      document.documentElement.lang = lang;
    } catch {
      /* ignore */
    }
  }, [lang]);

  const t = useCallback((key) => getTranslation(lang, key), [lang]);

  return (
    <LanguageContext.Provider value={{ lang, setLang, t, languages: LANGUAGES }}>
      {children}
    </LanguageContext.Provider>
  );
}

export function useLanguage() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error("useLanguage must be used inside LanguageProvider");
  return ctx;
}
